import { render } from "./PythonQuickstartView.vue?vue&type=template&id=4dcdf0c6"
import script from "./PythonQuickstartView.vue?vue&type=script&lang=js"
export * from "./PythonQuickstartView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__